import { isEmptyString, isNil } from '../../../../utilities/type-guards';

export const generateAnonInitials = (name: string | null | undefined): string => {
  if (isNil(name) || isEmptyString(name)) {
    return '';
  }

  const splitName = name.trim().split(' ');
  const namesToInitialize = [splitName[0]];

  const numNames = splitName.length;
  if (numNames > 1) {
    namesToInitialize.push(splitName[numNames - 1]);
  }

  return namesToInitialize
    .map((word) => word.charAt(0))
    .join('')
    .toUpperCase();
};
